/** @jsx jsx */
/* eslint-disable-next-line */
import React from 'react'
import { Box, jsx } from 'theme-ui'
import { node } from 'prop-types'
import { Location } from '@reach/router'

// styles
import './layout.css'
import GlobalFontStyle from '../fonts/typography'

// components
import NavigationHeader from './header/NavigationHeader'
import QuestionStepHeader from './header/QuestionStepHeader'
import Footer from './footer/Footer'
import { useSiteMetadata } from '../utils/useSiteMetadata'
import VWO from './header/VWO'

// wraps all app content, sits below Navigation
const Main = ({ ...props }) => (
  <Box
    as="main"
    {...props}
    sx={{
      margin: '0 auto',
      backgroundColor: 'background',
      minHeight: '100vh',
      width: '100%',
    }}
  />
)

// Layout component meant to wrap all pages in the app
// Includes CSS reset from Layout.css, Fonts, and the Navigation Header
const Layout = ({ children }) => {
  const { title } = useSiteMetadata()
  return (
    <Box
      id="seanBox"
      sx={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <GlobalFontStyle />
      <VWO />
      <Location>
        {({ location }) => (
          <>
            {location.pathname.includes('/StrategyBuilder/Section') ? (
              <QuestionStepHeader />
            ) : (
              <NavigationHeader siteTitle={title} />
            )}
            <Main>{children}</Main>
            <Footer />
          </>
        )}
      </Location>
    </Box>
  )
}

Layout.propTypes = {
  children: node.isRequired,
}

export default Layout
